import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Wallet,
  PieChart,
  Receipt,
  Target,
  TrendingUp,
  Users,
  FolderLock,
  Settings as SettingsIcon,
  LogOut,
} from 'lucide-react';
import { useAuth } from '@/App';
import NotificationBell from '@/components/NotificationBell';

const Sidebar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const menuItems = [
    { path: '/', icon: Wallet, label: 'Portfolio', testId: 'nav-portfolio' },
    { path: '/wealth/accounts', icon: Receipt, label: 'Accounts', testId: 'nav-accounts' },
    { path: '/wealth/allocation', icon: PieChart, label: 'Allocation', testId: 'nav-allocation' },
    { path: '/wealth/goals', icon: Target, label: 'Goals', testId: 'nav-goals' },
    { path: '/wealth/documents', icon: FolderLock, label: 'Documents', testId: 'nav-documents' },
    { path: '/wealth/household', icon: Users, label: 'Household', testId: 'nav-household' },
    { path: '/spending', icon: TrendingUp, label: 'Spending', testId: 'nav-spending' },
    { path: '/settings', icon: SettingsIcon, label: 'Settings', testId: 'nav-settings' },
  ];

  return (
    <div className="fixed left-0 top-0 h-screen w-64 bg-slate-900 text-white flex flex-col" data-testid="sidebar">
      <div className="p-6 border-b border-slate-800 flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-chivo font-bold tracking-tight">FinanceOS</h1>
          <p className="text-slate-400 text-sm mt-1 font-ibm">Personal Wealth</p>
        </div>
        <NotificationBell />
      </div>

      <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              data-testid={item.testId}
              className={`flex items-center gap-3 px-4 py-3 rounded-sm transition-colors ${
                isActive
                  ? 'bg-slate-800 text-white'
                  : 'text-slate-400 hover:text-white hover:bg-slate-800'
              }`}
            >
              <Icon size={20} />
              <span className="font-ibm font-medium">{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="p-4 border-t border-slate-800">
        <div className="mb-4 px-4">
          <p className="text-sm font-ibm font-semibold text-white" data-testid="user-name">{user?.name}</p>
          <p className="text-xs text-slate-400 uppercase tracking-widest font-ibm" data-testid="user-role">{user?.role}</p>
        </div>
        <button
          onClick={logout}
          data-testid="logout-button"
          className="w-full flex items-center gap-3 px-4 py-3 rounded-sm text-slate-400 hover:text-white hover:bg-slate-800 transition-colors"
        >
          <LogOut size={20} />
          <span className="font-ibm font-medium">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
